export default __webpack_public_path__ + "static/media/11455.f619cfed.jpg";